import { BoundingBox2, BoundingBox2FromLRTB } from '../../share/boundingbox2';

import { Plane2Model } from '../../model';
import { Vector2 } from 'three';

export type ScaleDirection = 'top' | 'bottom' | 'left' | 'right';
export interface CornerDirection {
  x: 'left' | 'right';
  y: 'top' | 'bottom';
}

export interface Ng3EdgeResizeEvent {
  type: 'edge';
  direction: ScaleDirection;
  to: number;
}
export interface Ng3CornerResizeEvent {
  type: 'corner';
  direction: CornerDirection;
  to: Vector2;
}
export type Ng3ScaleEvent = Ng3CornerResizeEvent | Ng3CornerResizeEvent;

export function updateBoxByDirection(
  direction: ScaleDirection,
  value: number,
  b: BoundingBox2
) {
  switch (direction) {
    case 'left':
      return new BoundingBox2FromLRTB(value, b.right, b.top, b.bottom);
    case 'right':
      return new BoundingBox2FromLRTB(b.left, value, b.top, b.bottom);
    case 'top':
      return new BoundingBox2FromLRTB(b.left, b.right, value, b.bottom);
    case 'bottom':
      return new BoundingBox2FromLRTB(b.left, b.right, b.top, value);
  }
}
export function resizePlane2ModelByEdge(
  e: Ng3EdgeResizeEvent,
  model: Plane2Model
) {
  return new Plane2Model(
    updateBoxByDirection(e.direction, e.to, model.box), 10,
    model.textureData
  );
}
export function resizePlane2ModelByCorner(
  e: Ng3CornerResizeEvent,
  model: Plane2Model
) {
  const xUpdated = updateBoxByDirection(e.direction.x, e.to.x, model.box);
  const box = updateBoxByDirection(e.direction.y, e.to.y, xUpdated);

  return new Plane2Model(box, 10, model.textureData);
}
